export default "__VITE_ASSET__CuBYkFpF__"